// extracted by mini-css-extract-plugin
module.exports = {"spacing-1":"spacing_spacing-1__D1azk","spacing-2":"spacing_spacing-2__948_B","spacing-3":"spacing_spacing-3__mWBB9","spacing-4":"spacing_spacing-4__1IeVR"};